export const gtmTags = {
  latam: 'GTM-KS6KNTT',
  na: 'GTM-WDZD3B9',
  eu: 'GTM-54CK984',
}
